import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'is24-corecss'
import { IconS24Lightbulb24 } from '@is24/cosma-ui-icons'

import { DepositGuaranteeModal } from './DepositGuaranteeModal'
import screenTooltipStyles from '../../../../../../common/display/screenTooltip/ScreenTooltip.module.css'
import styles from './DepositGuarantee.module.css'

export const DepositGuaranteeTip: React.FC = () => {
  const { t } = useTranslation()
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <>
      <aside className={`${screenTooltipStyles.statusMessage} padding-m border-left palm-hide lap-hide`}>
        <div className={`${styles.tipTitle} font-body-small-bold`}>
          <IconS24Lightbulb24 width={16} height={16} aria-hidden='true' focusable='false' />
          {t('wizard.screen.costs.depositGuarantee.tip.title')}
        </div>
        <p className={`${styles.tipCopy} margin-top font-body-small-regular`}>
          {t('wizard.screen.costs.depositGuarantee.tip.description')}{' '}
          <Link
            as='button'
            type='button'
            variant='blue'
            className={styles.tipLink}
            onClick={() => setIsModalOpen(true)}
          >
            {t('wizard.screen.costs.depositGuarantee.tip.readMore')}
          </Link>
        </p>
      </aside>
      <DepositGuaranteeModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  )
}
